// extracted by mini-css-extract-plugin
module.exports = {"Button":"DisconnectWallet_Button__1RGUP"};